<template>
    <div class="award-options">
      <q-btn-dropdown
      :label="menuLabel" 
      menu-anchor="bottom middle" 
      menu-self="top middle"
      >   
        <q-list>
          <q-item class="menu-heading-background" v-close-popup @click="onItemClick">
            <q-item-section>
              <q-item-label class="menu-heading"><b>Undergraduate</b></q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('Foundation', 'Undergraduate', 'Foundation degree')">
            <q-item-section>
              <q-item-label>Foundation degree</q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('LevelFiveAndSix', 'Undergraduate', 'Bachelor\'s or Integrated Master\'s degree')">
            <q-item-section>
              <q-item-label>Bachelor's or Integrated Master's degree</q-item-label>
            </q-item-section>
          </q-item>
          <q-item class="menu-heading-background" v-close-popup @click="onItemClick">
            <q-item-section>
              <q-item-label class="menu-heading"><b>Postgraduate</b></q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onItemClick('Masters', 'Postgraduate', 'Master\'s degree')">
            <q-item-section>
              <q-item-label>Master’s degree</q-item-label>
            </q-item-section>
          </q-item> 
        </q-list>
      </q-btn-dropdown>
    </div>
</template>

<script setup>

      import {ref} from "vue"

      const emit = defineEmits(['menu'])

      const menuLabel = ref("Select your Undergraduate or Postgraduate Award")

      const onItemClick = (menuItem, heading, title) => {
         menuLabel.value = title
         emit("menu", menuItem, heading)
      }

</script>

